import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { COMMON_WEB_PATH, LOTTERY_LINK } from "../../../constant";
import LazyImage from "../../../components/Loading/lazyImage";
import { useSelector } from "react-redux";
import { languageTransfer } from "../../../utils/languageTransfer";
import i18next from "i18next";

const NowGame = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`gamebox.${key}`);
  const i18n_common = (key) => t(`common.${key}`);

  const gameConfig = useSelector((state) => state.isGameConfig);

  const { game_platform, gameCode, game_subtype } = gameConfig;

  const gameName = useMemo(() => {
    return gameConfig?.[
      `gameName${languageTransfer({ lang: i18next.language })}`
    ];
  }, [gameConfig, i18next.language]);

  return (
    <section className="flex flex-col gap-[10px] mb-[10px]">
      <div className="flex flex-col gap-[3px] items-start justify-between">
        <span className="font-medium text-lg text-transaction-text dark:text-light-white">
          {i18n("gamePlatformNow")}
        </span>
        {gameConfig?.game_type === "LOTTERY" && (
          <a
            href={LOTTERY_LINK}
            target="_blank"
            className="text-main-color text-xs underline"
          >
            {`>>`} {i18n_common("vietInstantLottery")}
          </a>
        )}
      </div>

      <section className="flex gap-[10px] rounded-[5px] p-[8px] bg-hover-transaction-card dark:bg-base-light-dark">
        <LazyImage
          closeInverted
          src={`${COMMON_WEB_PATH}/gameIcon/en/${game_platform}/${gameCode}.webp`}
          className={`w-[65px] h-[65px] rounded-[10px] mr-[15px]`}
        />
        <div className="flex flex-col text-dark-gray-text dark:text-light-white">
          <p className="text-xl font-bold mb-[5px]">{gameName}</p>
          <p className="text-light-text text-lg mb-[20px]">
            {game_platform} - {i18n_common(game_subtype)}
          </p>
        </div>
      </section>
    </section>
  );
};

export default NowGame;
